export const addScript = ({
  id,
  src,
}: {
  id: string;
  src: string;
}): Promise<Event | boolean> =>
  new Promise((resolve, reject) => {
    const element = document.getElementById(id);
    if (element) {
      return resolve(true);
    }

    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('id', id);
    script.setAttribute('src', src);
    script.addEventListener('load', resolve);
    script.addEventListener('error', () =>
      reject(new Error(`Error loading ${id}.`))
    );
    script.addEventListener('abort', () =>
      reject(new Error(`${id} loading aborted.`))
    );
    document.getElementsByTagName('head')[0].appendChild(script);
  });
export const addAppleScript = (): Promise<Event | boolean> => {
  const src =
    '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
  return addScript({ id: 'apple-auth', src });
};
